export default {
  root: {
    backgroundColor: 'rgb(255 255 255 / 5%)',
  },
};
